import React from 'react';

interface SpinnerProps {
  spinnerClassNames?: string;
  pathClassNames?: string;
}

const Spinner = ({
  spinnerClassNames: spinnerClassName,
  pathClassNames: pathClassName,
}: SpinnerProps) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={spinnerClassName}
  >
    <path
      d="M2 14C2 20.6274 7.37258 26 14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2"
      stroke="#655DFD"
      strokeWidth="4"
      strokeLinecap="round"
      className={pathClassName}
    />
  </svg>
);

export default Spinner;
